import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconVoiceHigh: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"voice-high, wave"} maskId="square-filled-radius-0-stroke-1-IconVoiceHigh"><path d="M7.99911 3H6.99911V21H7.99911V3Z" fill="currentColor"/><path d="M17 5H16V19H17V5Z" fill="currentColor"/><path d="M12.4991 7H11.4991V17H12.4991V7Z" fill="currentColor"/><path d="M4 9H3V15H4V9Z" fill="currentColor"/><path d="M21 9H20V15H21V9Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconVoiceHigh;
